export default "__VITE_ASSET__BhN0ZxWA__"